import * as React from 'react';
import * as ReactDOM from 'react-dom';

import KendoBaseComponent, { KendoWidgetProps } from '@progress/kendo-base-component-react-wrapper';

export interface DateTimePickerProps extends KendoWidgetProps, kendo.ui.DateTimePickerOptions {
    children?: React.ReactNode;
}

export default class DateTimePicker extends KendoBaseComponent<DateTimePickerProps, {}> {
    componentDidMount(): void {
        const domNode = this.domNode;
        const { children, widgetRef, ...props } = this.props;

        if (domNode) {
            this.widgetInstance = new kendo.ui
                .DateTimePicker(domNode as Element, (props as kendo.ui.DateTimePickerOptions));
            super.componentDidMount();
        }
    }

    render(): any {
        if (this.didMount) {
            const { children, widgetRef, ...props } = this.props;

            this.widgetInstance.setOptions(props);
            (this.widgetInstance as kendo.ui.DateTimePicker).value(props.value as Date);
        }

        const domChild = React.Children
            .toArray(this.props.children)
            .filter((child: React.ReactElement<any>) => child && (child.type === 'input'))
            .shift();

        return domChild
            ? React.cloneElement(domChild, { ...domChild.props, ref: this.elementRef })
            : <input ref={this.elementRef} />;
    }
}



// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-react-wrapper/src/datetimepicker/index.tsx